import React, { useContext, useEffect, useRef, useState } from 'react'
import Search from '../Components/Images/search-lg.svg'
import { IoArrowDownSharp } from 'react-icons/io5'
import menus from '../Components/Images/menu.png';
import { Context } from '../Context/Context';
import countries from './Countries';
import DeleteMultipleModal from './DeleteMultipleModal';
import close from '../Components/Images/x-close.png';
import warn from '../Components/Images/Warn.svg'

const BeneficiaryInfo = ({ UserBeneficiaryDetails }) => {

    const [beneficiaryType, setBeneficiaryType] = useState('all')
    const [menu, setMenu] = useState(null)
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedIds, setSelectedIds] = useState([]);
    const selectAllRef = useRef();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteBenBar, setDeleteBenBar] = useState(false);
    const [deleteErrorBar, setDeleteErrorBar] = useState(false);

    const { handleViewDetails, handleDeleteProfile, fetchBeneficiaries } = useContext(Context)

    const [isSmScreen, setIsSmScreen] = useState(window.innerWidth < 500);

    const filteredBeneficiaries = beneficiaryType === 'all'
        ? UserBeneficiaryDetails.filter(ben =>
            (ben.full_name?.toLowerCase().includes(searchQuery.toLowerCase())) ||
            ((ben.account_type !== "crypto") && 'bank transfer'.includes(searchQuery.toLowerCase())) ||
            (ben.country?.toLowerCase().includes(searchQuery.toLowerCase())) ||
            (ben.account_number?.toLowerCase().includes(searchQuery.toLowerCase())) ||
            (ben.cryptocurrency_type?.toLowerCase().includes(searchQuery.toLowerCase())) ||
            (ben.wallet_address?.toLowerCase().includes(searchQuery.toLowerCase()))
        )
        : UserBeneficiaryDetails.filter(ben => {
            if (beneficiaryType === 'BT') {
                return ben.account_type === 'fiat' && (
                    (ben.full_name?.toLowerCase().includes(searchQuery.toLowerCase())) ||
                    (ben.account_number?.toLowerCase().includes(searchQuery.toLowerCase())) ||
                    ((ben.account_type !== "crypto") && 'bank transfer'.includes(searchQuery.toLowerCase()))
                );
            } else if (beneficiaryType === 'cry') {
                return ['USDT', 'SOL', 'BTC', 'USDC', 'BNB', 'ETH'].includes(ben.cryptocurrency_type) && (
                    (ben.full_name?.toLowerCase().includes(searchQuery.toLowerCase())) ||
                    (ben.cryptocurrency_type?.toLowerCase().includes(searchQuery.toLowerCase())) ||
                    (ben.wallet_address?.toLowerCase().includes(searchQuery.toLowerCase()))
                );
            }
            return true;
        });

    useEffect(() => {
        const handleResize = () => {
            setIsSmScreen(window.innerWidth < 500);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleBeneficairyClick = (id) => {
        localStorage.setItem('BeneficairyID', id);
    };

    const handleSearch = (query) => {
        setSearchQuery(query);  // Update the search query state
    };

    const toggleSelect = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    const toggleSelectAll = (checked) => {
        if (checked) {
            // Select all filtered beneficiaries
            const allIds = filteredBeneficiaries.map(ben => ben.id);
            setSelectedIds(allIds);
        } else {
            // Deselect all
            setSelectedIds([]);
        }
    };


    useEffect(() => {
        if (selectAllRef.current) {
            if (selectedIds.length === 0) {
                selectAllRef.current.indeterminate = false;
                selectAllRef.current.checked = false;
            } else if (selectedIds.length === filteredBeneficiaries.length) {
                selectAllRef.current.indeterminate = false;
                selectAllRef.current.checked = true;
            } else {
                selectAllRef.current.indeterminate = true;
            }
        }
    }, [selectedIds, filteredBeneficiaries]);

    useEffect(() => {
        if (deleteBenBar) {
            setTimeout(() => {
                setDeleteBenBar(false)
            }, 4200);
        }
        if (deleteErrorBar) {
            setTimeout(() => {
                setDeleteErrorBar(false)
            }, 5200);
        }
    }, [deleteBenBar, deleteErrorBar])

    return (
        <div className='md:px-10 mx-4 text-[#525154]'>
            <div className='flex gap-5 border-b-[1.3px]'>
                <p
                    onClick={() => setBeneficiaryType('all')}
                    className={beneficiaryType === 'all' ? 'text-[#531CB3] text-[16px] border-b-[#531CB3] border-b-2 cursor-pointer py-3 transition-colors duration-700 font-medium' : 'font-medium text-[16px] cursor-pointer py-[11px]'}
                >
                    All
                </p>
                <p
                    onClick={() => setBeneficiaryType('BT')}
                    className={beneficiaryType === 'BT' ? 'text-[#531CB3] text-[16px] border-b-[#531CB3] border-b-2 cursor-pointer py-3 transition-colors duration-700 font-medium' : 'font-medium text-[16px] cursor-pointer py-[11px]'}
                >
                    Bank Transfer
                </p>
                <p
                    onClick={() => setBeneficiaryType('cry')}
                    className={beneficiaryType === 'cry' ? 'text-[#531CB3] text-[16px] border-b-[#531CB3] border-b-2 cursor-pointer py-3 transition-colors duration-700 font-medium' : 'font-medium text-[16px] cursor-pointer py-[11px]'}
                >
                    Cryptocurrency
                </p>
            </div>

            <div className='py-10 relative'>
                {selectedIds.length > 0 && (
                    <div className="flex justify-end absolute z-50 top-0 right-0 my-4">
                        <button
                            onClick={() => setShowDeleteModal(true)}
                            className="bg-red-600 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-700"
                        >
                            Delete Selected ({selectedIds.length})
                        </button>
                    </div>
                )}

                <div className='relative'>
                    <input
                        type="text"
                        placeholder="Search for account, by name, account type or account number"
                        value={searchQuery}
                        onChange={(e) => handleSearch(e.target.value)}
                        className="px-4 py-2 border-none outline-none border-gray-300 w-full placeholder:text-[14px] placeholder:text-[#78757A] ml-5 rounded-md"
                    />
                    <img src={Search} alt="" className='absolute top-2' />
                </div>

                <div className='sm:grid md:grid-cols-5 sm:grid-cols-4 flex justify-between gap-5 border-t-[1.2px] border-b-[1.2px] px-3 text-[#78757A] border-[#F3F0F7] mt-3 py-[14px] text-[14px] font-medium text-left'>
                    <div className='flex items-center min-w-0'>
                        <input
                            ref={selectAllRef}
                            className="mt-1 mr-5 size-4 cursor-pointer"
                            type="checkbox"
                            onChange={(e) => toggleSelectAll(e.target.checked)}
                        />
                        <p className='truncate'>Account name</p>
                        <IoArrowDownSharp className='mt-1 xl:text-[16px] lg:text-[25px]' />
                    </div>
                    <div className='flex gap-2 items-center justify- min-w-0'>
                        <p className='truncate'>Account type</p>
                        <IoArrowDownSharp className='mt-1 text-[16px]' />
                    </div>
                    <div className='sm:flex hidden gap-2 items-center justify- min-w-0'>
                        <p className='truncate'>Country</p>
                        <IoArrowDownSharp className='mt-1 text-[16px]' />
                    </div>
                    <div className='md:flex hidden items-center justify- min-w-0'>
                        <p className='truncate'>Address</p>
                    </div>
                    <div className='min-w-0 sp:flex items-center justify-end hidden gap-5'>
                        <p className='truncate'>Account number</p>
                        <div className='cursor-pointer mt-[-10px] invisible'>
                            <p className='font-semibold text-[18px] text-black/60'>...</p>
                        </div>
                    </div>
                </div>
                {filteredBeneficiaries.map((Ben, i) => (
                    <div
                        key={i}
                        onClick={isSmScreen ? () => {
                            handleViewDetails(i)
                            handleBeneficairyClick(Ben.id)
                            setMenu(menu === i ? null : i)
                        }
                            : undefined}
                        className='sm:grid md:grid-cols-5 sm:grid-cols-4 flex justify-between gap-5 hover:bg-[#F3F0F7] cursor-pointer border-b-[1.2px] text-[#525154] border-[#F3F0F7] py-[14px] px-3 text-[14px] font-normal text-left'
                    >
                        <div className='flex gap-5 items-center min-w-0'>
                            <input
                                className='mt-1 size-4 cursor-pointer'
                                type="checkbox"
                                checked={selectedIds.includes(Ben.id)}
                                onChange={() => toggleSelect(Ben.id)}
                            />
                            <p className='truncate'>{Ben.full_name}</p>
                        </div>

                        <div className='min-w-0'>
                            <p className='truncate'>
                                {Ben.account_type === 'crypto' ? (
                                    Ben.cryptocurrency_type
                                ) : (
                                    'Bank Transfer'
                                )}
                            </p>
                        </div>

                        <div className='min-w-0 sm:block hidden'>
                            {Ben.country_code !== null ? (
                                <div className='truncate flex gap-1 items-center'>
                                    <img
                                        src={`https://flagcdn.com/w40/${Ben.country_code.toLowerCase()}.png`}
                                        alt={Ben.country_code.toLowerCase()}
                                        className="w-[20px] h-4 rounded-sm"
                                    />
                                    {countries.filter(country => Ben.country_code === country.code).map(name => name.name)}
                                </div>
                            ) : (
                                <p>—</p>
                            )}
                        </div>

                        <div className='min-w-0 md:block hidden'>
                            {Ben.wallet_address !== null ? (
                                <p className='truncate'>{Ben.wallet_address}</p>
                            ) : (
                                <p>—</p>
                            )}
                        </div>

                        <div className='min-w-0 sp:flex hidden justify-end items-center gap-5 relative'>
                            {Ben.account_number || Ben.nuban_code ? (
                                <p className="truncate">{Ben.account_number || Ben.nuban_code}</p>
                            ) : (
                                <p>—</p>
                            )}
                            <div
                                onClick={() => setMenu(menu === i ? null : i)}
                                className={`font-semibold text-[18px] text-black/60 ${menu === i ? 'bg-[#E6E4EB] rounded-md p-2 py-3' : 'py-2'}`}
                            >
                                <img src={menus} alt="" />
                            </div>
                            {menu === i && (
                                <div className='bg-white z-10 flex flex-col py-2 px- right-[-2px] absolute top-[37px] shadow-md rounded-md'>
                                    <p
                                        onClick={() => {
                                            handleViewDetails()
                                            handleBeneficairyClick(Ben.id)
                                            setMenu(menu === i ? null : i)
                                        }}
                                        className='cursor-pointer hover:bg-[#F9F7FC] px-4 py-1'
                                    >
                                        View profile
                                    </p>
                                    {/* <p
                                        onClick={() => {
                                            handleProfileEdit()
                                            handleBeneficairyClick(Ben.id)
                                            setMenu(menu === i ? null : i)
                                        }}
                                        className='cursor-pointer hover:bg-[#F9F7FC] px-4 py-1'
                                    >
                                        Edit profile
                                    </p> */}
                                    <p
                                        onClick={() => {
                                            handleDeleteProfile()
                                            handleBeneficairyClick(Ben.id)
                                            setMenu(menu === i ? null : i)
                                        }}
                                        className='cursor-pointer hover:bg-[#F9F7FC] px-4 py-1'
                                    >
                                        Delete profile
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                ))}

                <p className='text-[#78757A] mt-4'>
                    {filteredBeneficiaries?.length} {filteredBeneficiaries?.length > 1 ? 'Accounts' : 'Account'}
                </p>
            </div>
            <DeleteMultipleModal
                open={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                ids={selectedIds}
                onConfirm={async (ids) => {
                    const token = localStorage.getItem('token');
                    const res = await fetch(
                        "https://reccur-141b5bf0e007.herokuapp.com/api/v1/beneficiary/delete-multiple",
                        {
                            method: "POST",
                            headers: {
                                Authorization: `Token ${token}`,
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({ ids }),
                        }
                    );

                    if (res.ok) {
                        setShowDeleteModal(false)
                        setDeleteBenBar(true);
                        setTimeout(() => {
                            fetchBeneficiaries();
                        }, 3000);
                    } else {
                        setDeleteErrorBar(true)
                    }
                }}
            />
            {deleteBenBar && (
                <div className='absolute md:top-24 z-50 top-10 sm:right-10 right-2 flex items-center  justify-between p-4 rounded-lg bg-[#1CB353] text-[#F9F7FC]'>
                    <div className='flex gap-2 items-start'>
                        <img className='mt-1' src={warn} alt="" />
                        <div>
                            <p className='text-[14px] text-[#F9F7FC] font-medium'>Account deleted.</p>
                            <p className='text-[14px] text-[#CFF9DE] font-normal'>You've successfully deleted ({selectedIds.length}) account(s)</p>
                        </div>
                        <img
                            onClick={() => setDeleteBenBar(false)}
                            className='size-[10px] cursor-pointer'
                            src={close}
                            alt=""
                        />
                    </div>
                </div>
            )}

            {deleteErrorBar && (
                <div className='absolute md:top-24 z-50 top-10 sm:right-10 right-2 flex items-center  justify-between p-4 rounded-lg bg-[#EF4444] text-[#F9F7FC]'>
                    <div className='flex gap-2 items-start'>
                        <img className='mt-1' src={warn} alt="" />
                        <div>
                            <p className='text-[14px] text-[#F9F7FC] font-medium'>Failed to delete account.</p>
                            <p className='text-[14px] text-[#CFF9DE] font-normal'>We couldn’t delete the account at the moment. Please try again later.</p>
                        </div>
                        <img
                            onClick={() => setDeleteErrorBar(false)}
                            className='size-[10px] cursor-pointer'
                            src={close}
                            alt=""
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default BeneficiaryInfo